const classes = (
  ...classList: (string | Record<string, boolean>)[]
): string => {
  const produce = (item: Record<string, boolean>): string => {
    return Object.entries(item)
      .filter(([, value]) => {
        return Boolean(value);
      })
      .map(([key]) => {
        return key;
      })
      .join(" ");
  };

  return classList
    .map((item) => {
      if (typeof item === "string") {
        return item;
      }

      return produce(item);
    })
    .join(" ");
};

export default classes;
